import React from 'react';
import {
  COLOR_ONE,
  COLOR_TWO,
  COLOR_THREE,
  COLOR_FOUR,
  COLOR_FIVE,
  COLOR_SIX,
  COLOR_SEVEN,
} from './eventColors'

const EventTag = (props) => {
  const { tag } = props;

  let tagText = '',
      tagColor = '#323741';

  switch(tag) {
    case 'volunteer_work':
      tagText = 'Volunteer Work';
      tagColor = COLOR_ONE;
      break;
    case 'awards':
      tagText = 'Awards';
      tagColor = COLOR_TWO;
      break;
    case 'community_outreach':
      tagText = 'Community Outreach';
      tagColor = COLOR_THREE;
      break;
    case 'dignitary_meetings':
      tagText = 'Dignitary Meeting';
      tagColor = COLOR_FOUR;
      break;
    case 'keynote_speech':
      tagText = 'Keynote Speech';
      tagColor = COLOR_FIVE;
      break;
    case 'interviews':
      tagText = 'Interviews';
      tagColor = COLOR_SIX;
      break;
    case 'videos':
      tagText = 'Videos';
      tagColor = COLOR_SIX;
      break;
    default:
      break;
  }

  return (
    <span
      className="item-tag"
      style={{ backgroundColor: tagColor}}
    >
      {tagText}
    </span>
  );
}

export default EventTag;
